import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import cn from 'classnames';

import TransitionHandler from './TransitionHandler';
import css from './CardTransition.scss';

type Props = {
	data: { _id?: string };
	className?: string;
	children: React.ReactNode;
};

const CardTransition = (props: Props) => (
	<TransitionGroup className={cn(css.transition, props.className)} appear enter exit>
		<TransitionHandler key={props.data._id}>{props.children}</TransitionHandler>
	</TransitionGroup>
);

export default CardTransition;

export { CardTransitionContext } from './TransitionHandler';
